// @ts-nocheck

import { reduce, orderBy, concat, find } from 'lodash';
import { createSelector } from 'reselect';

import { selectEntitiesBets } from '../../../selectors/entities/bets/entitiesBetsPrimary.selector';
import { selectEntitiesMatchesEntity } from '../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { selectEntitiesOdds } from '../../../selectors/entities/odds/entitiesOddsPrimary.selector';
import { selectEntitiesOutcomes } from '../../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';
import { bet as BetStateUtils, odd as OddUtils } from '../../../utils';
import { createShallowEqualSelector } from '../../../utils/reselect';
import sortOutcomesFromTemplate from '../utils/sortOutcomesFromTemplate';

const emptyArray: [] = [];

const getSelectedBetGroupId = (state) => state.immersive.selectedBetGroupId;
const getFilterFunction = (_, { filterFunc }) => filterFunc;

const getMatchBetIds = createSelector([selectEntitiesMatchesEntity], (match) => {
  return (match && match.bets) || emptyArray;
});

const getMatchAvailable = createSelector([selectEntitiesMatchesEntity], (match) => {
  return (match && match.available) || false;
});

export const getMatchBets = createSelector([getMatchBetIds, selectEntitiesBets], (ids, bets) => {
  return ids
    .map((id) => {
      if (bets[id]) {
        return bets[id];
      }
      return null;
    })
    .filter((k) => k);
});

// intermediaire reducer
const getMatchOutcomesIds = createSelector([getMatchBets], (bets) => {
  return reduce(
    bets,
    (result, bet) => {
      return concat(result, bet.outcomes);
    },
    [],
  );
});

export const getMatchOdds = createShallowEqualSelector(
  [getMatchOutcomesIds, selectEntitiesOdds],
  (outcomesIds, odds) => {
    return outcomesIds.reduce((result, outcomeId) => {
      return { ...result, [outcomeId]: odds[outcomeId] };
    }, {});
  },
);

export const getBetGroups = createShallowEqualSelector(
  [getMatchBets, getFilterFunction, getMatchAvailable, getMatchOdds],
  (bets, filterFunc, matchIsAvailable, odds) => {
    let finalBets = bets;

    if (typeof filterFunc === 'function') {
      finalBets = filterFunc(bets);
    }

    const groups = reduce(
      finalBets,
      (finalGroup, bet, index) => {
        const group = bet.betGroup;
        const { template } = bet;
        const betIsAvailable = bet.available;

        bet.outcomes = BetStateUtils.filterOutcomesByTemplate(
          template,
          bet.outcomes,
          matchIsAvailable,
          betIsAvailable,
          odds,
        );

        if (!finalGroup[group]) {
          finalGroup[group] = { index, bets: [bet], totalOutcomes: bet.outcomes ? bet.outcomes.length : 0 };
        } else {
          finalGroup[group].bets.push(bet);
          finalGroup[group].totalOutcomes += bet.outcomes ? bet.outcomes.length : 0;
        }
        return finalGroup;
      },
      {},
    );
    return orderBy(groups, ['index']);
  },
);

export const getFormatedBets = createSelector([getBetGroups], (betGroups) => {
  return betGroups.reduce((acc, group) => {
    const firstBet = group.bets[0];
    return [...acc, { label: firstBet.betTitle, id: firstBet.betGroup }];
  }, []);
});

export const getBetGroupBets = createSelector([getBetGroups, getSelectedBetGroupId], (betGroups, betGroup) => {
  const finalBetGroup = find(betGroups, (group) => group.bets[0].betGroup === betGroup);
  return (finalBetGroup && finalBetGroup.bets) || [];
});

export const getBetGroupOutcomes = createSelector(
  [getMatchAvailable, getBetGroupBets, selectEntitiesOutcomes, selectEntitiesOdds],
  (isMatchAvailable, bets, outcomes, odds) => {
    return bets.reduce((acc, bet) => {
      const betId = bet.betId;
      const template = bet.template;
      const newOutcomes = bet.outcomes.map((outcomeId) => {
        const outcome = outcomes[outcomeId];
        const mode = OddUtils.getMode({
          matchIsAvailable: isMatchAvailable,
          betIsAvailable: bet.available || false,
          betTemplate: template,
          oddValue: odds[outcomeId],
          outcomeIsAvailable: outcome.available ?? true,
        });
        return {
          ...outcome,
          betId,
          mode,
          value: odds[outcomeId],
        };
      });
      const sortedOutcomes = sortOutcomesFromTemplate(newOutcomes, template);
      return [...acc, sortedOutcomes];
    }, []);
  },
);

export const getSelectedBet = createSelector([getFormatedBets, getSelectedBetGroupId], (bets, selectedBetGroupId) => {
  const selectedBet = find(bets, (bet) => bet.id === selectedBetGroupId);
  return selectedBetGroupId && selectedBet ? { id: selectedBetGroupId, label: selectedBet.label } : null;
});

export const outcomesListSelector = createSelector(
  [getFormatedBets, getSelectedBet, getBetGroupOutcomes],
  (bets, selectedBet, outcomes) => {
    return {
      bets,
      selectedBet,
      outcomes,
    };
  },
);
